import { Component, Input } from "@angular/core";
import { PlanningActivity } from "../../../shared/types";

@Component({
	selector: "activity-item",
	templateUrl: "./activity-item.component.html",
	styleUrls: ["./activity-item.component.scss"],
	standalone: false,
})
export class ActivityItemComponent {
	// @ts-expect-error TS2564
	@Input() activity: PlanningActivity;
}
